// =============================================================================
// Constants — URL/링크 상수 모음
// 우진 (2026-04-30): 리뉴얼 페이지(Landing/Membership/Retail-Pos/Food-Pos/CRM/
// Cases/Policy) 와 Banner.js 다운로드 / Policy 본문 링크 / MiniModal 가이드만
// 남기고 레거시 페이지 전용 URL 일괄 정리.
// =============================================================================

export default {
  // 리뉴얼 CTA (랜딩/멤버십/리테일/푸드/CRM hero·footer 공용)
  DASHBOARD_HOME: "https://dashboard.thegrowing.co/",
  CHANNEL_TALK: "https://growingsales.channel.io/",
  CONSULT_FORM: "https://forms.gle/bmaTfPBSNNMgryKP8",

  // 가입/추적 URL — Gtag.js 가 SIGNUP_URL 매칭에 사용 (외부 가입 트래킹)
  SIGNUP_URL: "http://dashboard.thegrowing.co/signup",

  // 개인정보처리방침 본문(policies/customer_*.js) 에서 참조
  FRANCHISE_URL: "https://thegrowing.co/franchise-list",

  // 다운로드 — Banner / FooterCta 의 AppStore / PlayStore / PC 버튼
  APPSTORE_URL:
    "https://apps.apple.com/us/app/%EA%B7%B8%EB%A1%9C%EC%9E%89%EC%84%B8%EC%9D%BC%EC%A6%88/id1471316655",
  PLAYSTORE_URL:
    "https://play.google.com/store/apps/details?id=com.thegrowing.sales",
  PC_DOWNLOAD: "https://download.thegrowing.co/GrowingSales.exe",

  // 멤버십 MiniModal 가이드 링크
  MINI_GUIDE: "https://support.thegrowing.co/growing-sales/product/pos/mini",
};
